export default {"src":"/_next/static/media/tel_icon.1cca29ac.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};